import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./ProductModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { SwiperSlide } from "swiper/react";
import { Swiper } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import { IDS } from "../../../utils/IDS";

const ProductModal = ({ show, handleClose, startIndex, images }) => {
  // const images = [
  //   "/images/product_info_page/img1.png",
  //   "/images/product_info_page/img2.png",
  //   "/images/product_info_page/img3.png",
  //   "/images/product_info_page/img1.png",
  //   "/images/product_info_page/img2.png",
  //   "/images/product_info_page/img3.png",
  // ];
  const [swiperReady, setSwiperReady] = useState(false);

  const [activeIndex, setActiveIndex] = useState(startIndex);
  const isFirst = activeIndex === 0;
  const isLast = activeIndex === images.length - 1;

  useEffect(() => {
    setActiveIndex(startIndex);
  }, [startIndex]);

  useEffect(() => {
    if (!show) {
      setSwiperReady(false);
    }
  }, [show]);
  const handleNext = () => {
    setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  return (
    <section className="product-modal-section">
      <Modal
        show={show}
        onHide={handleClose}
        onEntered={() => setSwiperReady(true)}
        centered
        dialogClassName="product-modal"
        size="md"
      >
        <Modal.Body className="custom-modal-body">
          {/* Main Image Section */}

          <div className="main-image-wrapper">
            <button
              className={`nav-btn left ${
                isFirst ? "disabled-arrow" : "active-arrow"
              }`}
              onClick={handlePrev}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>

            <img
              src={`${IDS.IMG_URL}${images?.[activeIndex]?.product_image}`}
              alt=""
              className="main-image"
            />

            <button
              className={`nav-btn right ${
                isLast ? "disabled-arrow" : "active-arrow"
              }`}
              onClick={handleNext}
            >
              <FontAwesomeIcon icon={faAngleRight} />
            </button>
          </div>

          <div className="thumbnail-wrapper">
            {swiperReady && (
              <Swiper
                slidesPerView={4}
                spaceBetween={10}
                grabCursor={true}
                freeMode={true}
                allowTouchMove={true}
                className="thumb-swiper"
                breakpoints={{
                  0: { slidesPerView: 3 },
                  576: { slidesPerView: 4 },
                  768: { slidesPerView: 5 },
                }}
              >
                {images?.map((img, index) => (
                  <SwiperSlide key={img.id}>
                    <img
                      src={`${IDS.IMG_URL}${img.product_image}`}
                      alt=""
                      className={`thumb-img ${
                        activeIndex === index ? "active-thumb" : ""
                      }`}
                      onClick={() => setActiveIndex(index)}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default ProductModal;
